import actionTypes from '../actions/actionTypes';
import { routeToPathMap } from './pages';

const defaultState = {
  isMinimized: null,
  isSideBarOpen: false,
};

function closeSideBar(state) {
  return Object.assign({}, state, {
    isSideBarOpen: false,
  });
}

export default function viewReducer(state = defaultState, action) {
  // Close sideBar on location change.
  if (routeToPathMap[action.type]) {
    return closeSideBar(state);
  }

  switch (action.type) {
    case actionTypes.SET_MINIMIZED_VIEW:
      return {
        isMinimized: action.isMinimized,
      };

    case actionTypes.OPEN_SIDEBAR:
      return {
        ...state,
        isSideBarOpen: true,
      };

    case actionTypes.CLOSE_SIDEBAR:
      return closeSideBar(state);

    default:
      break;
  }

  return state;
}



// WEBPACK FOOTER //
// ./application/store/viewReducer.js